<div class="chart-container">
  <div class="chart-content">
    <div *ngIf="loading" style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
      <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }" style="width: 100%;"></nz-skeleton>
    </div>
    <canvas 
      *ngIf="!loading && chartData"
      baseChart 
      [data]="chartData" 
      [options]="chartOptions" 
      [type]="'bar'">
    </canvas>
  </div>
</div>
